<template>
  <a-modal
    title="选择会员"
    :width="900"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    :bodyStyle="{}"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="搜索条件">
              <a-select v-model="queryParam.search_condition" placeholder="请选择查询类型" allowClear>
                <a-select-option value="1">微信昵称</a-select-option>
                  <a-select-option value="2">会员ID</a-select-option>
                  <a-select-option value="3">上级ID</a-select-option>
                  <a-select-option value="4">微信ID</a-select-option>
                  <a-select-option value="5">追单号</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="请先选择查询类型"/>
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table v-if="currentRobotId" ref="table" rowKey="uid" :columns="columns" :data="loadData">
      <span slot="avatar" slot-scope="text">
        <a-avatar shape="square" size="small" icon="user" :src="text"/>
      </span>
      <span slot="nickname" slot-scope="text">
        <span v-line-clamp="1">{{ text }}</span>
      </span>
      <!-- <span slot="wx_id" slot-scope="text,record">
        <span v-line-clamp="1">{{ record }}</span>
      </span> -->
      <template slot="balance" slot-scope="text">
        <span>{{ text || 0 | currency('￥') }}</span>
      </template>
      <template slot="action" slot-scope="text,record">
         <a @click="onchange(record)">选择</a>
      </template>
    </s-table>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: 'UID',
    width: 100,
    dataIndex: 'uid'
  },
  {
    title: '微信头像',
    dataIndex: 'avatar',
    width: 150,
    scopedSlots: { customRender: 'avatar' }
  },
  {
    title: '微信昵称',
    dataIndex: 'nickname',
    width: 300,
    scopedSlots: { customRender: 'nickname' }
  },
  // {
  //   title: '微信ID',
  //   dataIndex: 'wxid',
  //   width: 200,
  //   scopedSlots: { customRender: 'wx_id' }
  // },
  {
    title: '余额',
    sorter: true,
    width: 150,
    dataIndex: 'balance',
    scopedSlots: { customRender: 'balance' }
  },
  {
    title: '操作',
    width: 100,
    scopedSlots: { customRender: 'action' }
  }
]
import FansApi from '@/api/fans'
import { STable } from '@/components'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      currentRobotId: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return FansApi.getFansList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        ).then(res => {
          return res
        })
      }
    }
  },
  created() {},
  methods: {
    show({robotid}) {
      // console.log(robotid)
      this.currentRobotId = robotid
      this.visible = true
    },
    handleCancel() {
      this.currentRobotId = null
      this.visible = false
    },
    onchange(record) {
      this.$emit('change',record)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
